import { EnumOption, ScreenSizeSpec, VirtualWaitingRoomSlideInfo } from "./types/interfaces";
import { Height } from "./types/types";

export const KEY_DisableSplash: string = 'disableSplash';
export const KEY_homeImage = 'homeImage';
export const KEY_ViewFlag = 'viewFlag';

export const KEY_session = 'session';
export const KEY_sessionId = 'sessionId';
export const KEY_sessionUserId = 'sessionUserId';
export const KEY_sessionUser = 'sessionUser';
export const KEY_language = 'language';
export const KEY_sessionLanguage = 'sessionLanguage';

export const KEY_patient = 'patient';
export const KEY_patient_name = 'patientName';

export const KEY_accessToken = 'accessToken';

export const KEY_scheduleInfo = 'scheduleInfo';

export const KEY_debug = 'dbg';

export const optionUnspecified: EnumOption = {
  value: '',
  display: 'Select',
};
export const IFrameDefaultHeight: Height = 800;
export const IFrameHeightUpdateIntervalTimeInMS: number = 500;
export const IFrameHeightUpdateCooldownTimeInMS: number = 2000;
// export const IFrameExtraHeight = 100;
export const IFrameExtraHeight = 250;
export const IFrameHeightPrecision = 250;

export const HomeScreenSizes: ScreenSizeSpec[] = [{ label: 'md', width: 1000 }, { label: 'lg', width: 1800 }, { label: 'xl', width: 2400 }];

export const VirtualWaitingRoomSlideSizes: ScreenSizeSpec[] = [
  { label: '375', width: 375 },
  { label: '412', width: 412 },
  { label: '430', width: 430 },
  { label: '768', width: 768 },
  { label: '820', width: 820 },
  // { label: '1024', width: 1024 },
  // { label: '1200', width: 1200 },
  // { label: '1600', width: 1600 },
  // { label: '1848', width: 1848 },
  // { label: '1920', width: 1920 },
  // { label: '2560', width: 2560 },
  // { label: '3840', width: 3840 }
];
export const VirtualWaitingRoomSlideFoldersRoot: string = '/images/VirtualWaitingRoom/';
// export const VirtualWaitingRoomSlideFolders: string[] = [
//   'Childrens',
//   'Compass',
//   'flu',
//   'Genome',
//   'Heart',
//   'Mammo',
//   'mymh',
//   'new_start',
//   'Primary_Care',
//   'resolution',
//   'sleep',
//   'Stroke',
//   'Womens',
// ];

export const MemorialHermannUrl = 'https://www.memorialhermann.org';
// export const VirtualWaitingRoomSlides: VirtualWaitingRoomSlideInfo[] = [
//   { imageName: 'Childrens', actionUrl: '/childrenshealth' },
//   { imageName: 'Compass', actionUrl: '//getcompasslifestyle' },
//   { imageName: 'flu', actionUrl: '/stoptheflu' },
//   { imageName: 'Genome', actionUrl: '/getgenoME' },
//   { imageName: 'Heart', actionUrl: '/getcardiaccare' },
//   { imageName: 'Mammo', actionUrl: '/breastcareforyou' },
//   { imageName: 'mymh', actionUrl: '/getmymh' },
//   { imageName: 'new_start', actionUrl: '/newstartforyou' },
//   { imageName: 'Primary_Care', actionUrl: '/getprimarycare' },
//   { imageName: 'resolution', actionUrl: '/getresolution' },
//   { imageName: 'sleep', actionUrl: '/sleepbetter' },
//   { imageName: 'Stroke', actionUrl: '/getstrokecare' },
//   { imageName: 'Womens', actionUrl: '/getwomenshealth' },
// ];
export const VirtualWaitingRoomCoreSlides: VirtualWaitingRoomSlideInfo[] = [
  {
    imageName: 'Flu',
    // actionUrl: '/stoptheflu'
  },
  {
    imageName: 'Genome',
    // actionUrl: '/getgenoME'
  },
  {
    imageName: 'Mammo',
    // actionUrl: '/breastcareforyou'
  },
  {
    imageName: 'MyMH',
    // actionUrl: '/getmymh'
  },
  {
    imageName: 'PrimaryCare',
    // actionUrl: '/getprimarycare'
  },
];
export const VirtualWaitingRoomExtraSlides: VirtualWaitingRoomSlideInfo[] = [
  {
    imageName: 'Children',
    // actionUrl: '/childrenshealth'
  },
  {
    imageName: 'Compass',
    // actionUrl: '//getcompasslifestyle'
  },
  {
    imageName: 'Heart',
    // actionUrl: '/getcardiaccare'
  },
  {
    imageName: 'NewStart',
    // actionUrl: '/newstartforyou'
  },
  {
    imageName: 'Resolution',
    // actionUrl: '/getresolution'
  },
  {
    imageName: 'Sleep',
    // actionUrl: '/sleepbetter'
  },
  {
    imageName: 'Stroke',
    // actionUrl: '/getstrokecare'
  },
  {
    imageName: 'Womens',
    // actionUrl: '/getwomenshealth'
  },
];

export const VirtualWaitingRoomSlides: VirtualWaitingRoomSlideInfo[] = [
  ...VirtualWaitingRoomCoreSlides,
  ...VirtualWaitingRoomExtraSlides
];

export const TranslatedVirtualWaitingRoomSlides: { [key: string]: VirtualWaitingRoomSlideInfo[] } = {
  // 'es': VirtualWaitingRoomCoreSlides,
  'vi': VirtualWaitingRoomCoreSlides,
  'zh': VirtualWaitingRoomCoreSlides,
  'ar': VirtualWaitingRoomCoreSlides,
  'en': VirtualWaitingRoomCoreSlides,
  'es': VirtualWaitingRoomCoreSlides
};

// const NoLocalization = false;
// export const SkipLocalization = NoLocalization ||
//   /iphone|ipod|ipad/.test(window.navigator.userAgent.toLowerCase()) ||
//   (new URL(window.location.href).searchParams).get('platform')?.toLowerCase() == 'ios';


export const SkipLocalization = false;
